/*
 * Generated type guards for "model.ts".
 * WARNING: Do not manually change this file.
 */
import { IPaypalOaltInitiateApiResponse } from "./model";

export function isPaypalOaltInitiateResponse(obj: any, _argumentName?: string): obj is IPaypalOaltInitiateApiResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        (obj.data !== null &&
            typeof obj.data === "object" ||
            typeof obj.data === "function") &&
        typeof obj.data.paypalOrderId === "string" &&
        (obj.data.orderId === null ||
            typeof obj.data.orderId === "number") &&
        Array.isArray(obj.data.links) &&
        obj.data.links.every((e: any) =>
            (e !== null &&
                typeof e === "object" ||
                typeof e === "function") &&
            typeof e.href === "string" &&
            typeof e.method === "string" &&
            typeof e.rel === "string"
        ) &&
        typeof obj.data.status === "string" &&
        (obj.data.paymentSource === null ||
            (obj.data.paymentSource !== null &&
                typeof obj.data.paymentSource === "object" ||
                typeof obj.data.paymentSource === "function") &&
            (obj.data.paymentSource.token === null ||
                (obj.data.paymentSource.token !== null &&
                    typeof obj.data.paymentSource.token === "object" ||
                    typeof obj.data.paymentSource.token === "function") &&
                typeof obj.data.paymentSource.token.id === "string" &&
                typeof obj.data.paymentSource.token.type === "string") &&
            (obj.data.paymentSource.paypal === null ||
                (obj.data.paymentSource.paypal !== null &&
                    typeof obj.data.paymentSource.paypal === "object" ||
                    typeof obj.data.paymentSource.paypal === "function") &&
                (obj.data.paymentSource.paypal.experienceContext === null ||
                    (obj.data.paymentSource.paypal.experienceContext !== null &&
                        typeof obj.data.paymentSource.paypal.experienceContext === "object" ||
                        typeof obj.data.paymentSource.paypal.experienceContext === "function") &&
                    typeof obj.data.paymentSource.paypal.experienceContext.returnUrl === "string" &&
                    typeof obj.data.paymentSource.paypal.experienceContext.cancelUrl === "string" &&
                    typeof obj.data.paymentSource.paypal.experienceContext.shippingPreference === "string" &&
                    typeof obj.data.paymentSource.paypal.experienceContext.userAction === "string") &&
                (obj.data.paymentSource.paypal.attributes === null ||
                    (obj.data.paymentSource.paypal.attributes !== null &&
                        typeof obj.data.paymentSource.paypal.attributes === "object" ||
                        typeof obj.data.paymentSource.paypal.attributes === "function") &&
                    (obj.data.paymentSource.paypal.attributes.vault !== null &&
                        typeof obj.data.paymentSource.paypal.attributes.vault === "object" ||
                        typeof obj.data.paymentSource.paypal.attributes.vault === "function") &&
                    typeof obj.data.paymentSource.paypal.attributes.vault.storeInVault === "string" &&
                    typeof obj.data.paymentSource.paypal.attributes.vault.usageType === "string" &&
                    typeof obj.data.paymentSource.paypal.attributes.vault.customerType === "string" &&
                    typeof obj.data.paymentSource.paypal.attributes.vault.id === "string" &&
                    typeof obj.data.paymentSource.paypal.attributes.vault.status === "string"))) &&
        Array.isArray(obj.messages) &&
        obj.messages.every((e: any) =>
            typeof e === "string"
        ) &&
        (typeof obj.reasonKeys === "undefined" ||
            Array.isArray(obj.reasonKeys) &&
            obj.reasonKeys.every((e: any) =>
                typeof e === "string"
            ))
    )
}
